<template>
  <div>

    <div class="form-row" v-show="step === false">

        <div class="form-group col-md-12">
            <label class="form-label" for="Insurance">Soll eine Versicherung den Schaden bezahlen?<span class="text-danger">*</span>:</label>
            <select class="form-control" v-model="insurance" id="Insurance" name="Insurance">
                <option value="">Bitte wählen</option>
                <option value="Ja">Ja</option>
                <option value="Nein">Nein</option>
            </select>
            <div class="invalid-feedback d-block" v-if="formerrors.includes('insurance')">
                Bitte treffen Sie eine Auswahl.
            </div>
            <button class="btn btn-primary my-3" @click="onSelectInsurance()">Weiter</button>
        </div>

    </div>

    <div class="form-row" v-show="step === 0" v-bind:class="{ 'active': step === 0 }">

        <div class="form-group col-md-12">
            <label class="form-label" for="Insurancetype">Handelt es sich um einen Haftpflicht- oder einen Kaskoschaden (Teil-/Vollkasko)?<span class="text-danger">*</span>:</label>
            <select class="form-control" v-model="insuranceData.damagetype" id="Insurancetype" name="Insurancetype">
                <option value="">Bitte wählen</option>
                <option value="Haftpflichtschaden">Haftpflichtschaden</option>
                <option value="Kaskoschaden (Teil-/Vollkasko)">Kaskoschaden (Teil-/Vollkasko)</option>
            </select>
            <div class="invalid-feedback d-block" v-if="formerrors.includes('damagetype')">
                Bitte treffen Sie eine Auswahl.
            </div>
            <button class="btn btn-primary my-3" @click="step = false">Zurück</button>
            <button class="btn btn-primary my-3" @click="onSelectDamagetype()">Weiter</button>
            <!-- Bei Haftpflichtschaden > Eintrag in Notiz "Haftpflichtschaden" > keine weiteren Fragen -->
            <!-- Bei Kaskoschaden > Eintrag in Notiz "Kaskoschaden" -->
        </div>

    </div>

    <div class="form-row" v-show="step == 1" v-bind:class="{ 'active': step == 1 }">

        <div class="form-group col-md-12">
            <label class="form-label">Bei welcher Versicherung sind Sie versichert?<span class="text-danger">*</span>:</label>
            <input type="text" v-model="insuranceData.company" class="form-control">
            <div class="invalid-feedback d-block" v-if="formerrors.includes('company')">
                Bitte geben Sie den Namen Ihrer Versicherung an.
            </div>
            <button class="btn btn-primary my-3" @click="step = 0">Zurück</button>
            <button class="btn btn-primary my-3" @click="onInputInsurance()">Weiter</button>
        </div>
        <!-- Eintrag in Notiz "Versicherung" -->

    </div>

    <div class="form-row" v-show="step == 2" v-bind:class="{ 'active': step == 2 }">

        <div class="form-group col-md-12">
            <label class="form-label" for="Insurancereported">Haben Sie den Schaden bereits gemeldet?<span class="text-danger">*</span>:</label>
            <select class="form-control" v-model="insuranceData.reported" id="Insurancereported" name="Insurancereported">
                <option value="">Bitte wählen</option>
                <option value="Ja">Ja</option>
                <option value="Nein">Nein</option>
            </select>
            <div class="invalid-feedback d-block" v-if="formerrors.includes('reported')">
                Bitte treffen Sie eine Auswahl.
            </div>
            <button class="btn btn-primary my-3" @click="step = 1">Zurück</button>
            <button class="btn btn-primary my-3" @click="onSelectReported()">Weiter</button>
        </div>
        <!-- Eintrag in Notiz "Schaden bei Versicherung gemeldet J/N"  -->

    </div>

    <div class="form-row" v-show="step == 3" v-bind:class="{ 'active': step == 3 }">

        <div class="form-group col-md-12">
            <label class="form-label" for="Damagenumber">Haben Sie bereits ein Schadensnummer erhalten?<span class="text-danger">*</span>:</label>
            <select class="form-control" v-model="insuranceData.hasdamagenumber" id="Damagenumber" name="Damagenumber">
                <option value="">Bitte wählen</option>
                <option value="Ja">Ja</option>
                <option value="Nein">Nein</option>
            </select>
            <div class="invalid-feedback d-block" v-if="formerrors.includes('hasdamagenumber')">
                Bitte treffen Sie eine Auswahl.
            </div>
            <button class="btn btn-primary my-3" @click="step = 2">Zurück</button>
            <button class="btn btn-primary my-3" @click="onSelectHasdamagenumber()">Weiter</button>
        </div>

    </div>

    <div class="form-row" v-show="step == 4" v-bind:class="{ 'active': step == 4 }">

        <div class="form-group col-md-12" v-show="insuranceData.hasdamagenumber == 'Ja'">
            <label class="form-label">Schadennummer?<span class="text-danger">*</span>:</label>
            <input type="text" v-model="insuranceData.damagenumber" class="form-control">
            <div class="invalid-feedback d-block" v-if="formerrors.includes('damagenumber')">
                Bitte geben Sie  Ihre Schadennummer an.
            </div>
            <button class="btn btn-primary my-3" @click="step = 3">Zurück</button>
            <button class="btn btn-primary my-3" @click="onInputDamagenumber()">Weiter</button>
        </div>
        <!-- Eintrag in Notiz "Schadensnummer" -->

    </div>

  </div>
</template>

<script>
export default {
    name: "Insurance",
    data() {
        return {
            insurance: '',
            insuranceData: { damagetype: '', company: '', reported: '', hasdamagenumber: '', damagenumber: '' },
            step: false,
            formerrors: []
        }
    },
    watch: {
        initInsuranceData: function(newVal, oldVal) { // watch it
          //console.log('Prop changed: ', newVal, ' | was: ', oldVal)
          if(newVal !== oldVal) {
            this.insuranceData = { damagetype: '', company: '', reported: '', hasdamagenumber: '', damagenumber: '' };
            this.step = false;
            this.formerrors = [];
          }
        }
    },
    methods: {
        onSelectInsurance() {
            if(this.insurance == '') {
                this.formerrors.push('insurance');
            }
            else {
                if(this.insurance == 'Ja') {
                    this.step = 0;
                }
                else {
                    this.updateParent();
                }
            }
        },
        onSelectDamagetype() {
            if(this.insuranceData.damagetype == '') {
                this.formerrors.push('damagetype');
            }
            else {
                if(this.insuranceData.damagetype == 'Kaskoschaden (Teil-/Vollkasko)') {
                    this.step = 1;
                }
                else {
                    this.updateParent();
                }
            }
        },
        onInputInsurance() {
            if(this.insuranceData.company == '') {
                this.formerrors.push('company');
            }
            else {
                this.step = 2;
            }
        },
        onSelectReported() {
            if(this.insuranceData.reported == '') {
                this.formerrors.push('reported');
            }
            else {
                if(this.insuranceData.reported == 'Ja') {
                    this.step = 3;
                }
                else {
                    this.updateParent();
                }
            }
        },
        onSelectHasdamagenumber() {
            if(this.insuranceData.hasdamagenumber == '') {
                this.formerrors.push('hasdamagenumber');
            }
            else {
                if(this.insuranceData.hasdamagenumber == 'Ja') {
                    this.step = 4;
                }
                else {
                    this.updateParent();
                }
            }
        },
        onInputDamagenumber() {
            if(this.insuranceData.damagenumber == '') {
                this.formerrors.push('damagenumber');
            }
            else {
                this.updateParent();
            }
        },
        updateParent() {
            this.$emit('insurance-data-completed', this.insuranceData);
        }
    },
    props: ['initInsuranceData']
};
</script>

<style>
.form-row.active label,
.form-row.active p {
    opacity: 0;
    transform: translateX(10px);
    animation: fadeEnter ease 750ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
}
/*.form-row.active p {
    animation-delay: 250ms
}*/
@keyframes fadeEnter {
    0% {
        opacity:0;
        transform: translateX(10px);
    }
    100% {
        opacity:1;
        transform: translateX(0);
    }
}
</style>
